__turbopack_context__.v({
  "ctaBlock": "LeaderboardHero-module___8BEVG__ctaBlock",
  "ctaLead": "LeaderboardHero-module___8BEVG__ctaLead",
  "eyebrow": "LeaderboardHero-module___8BEVG__eyebrow" + " " + __turbopack_context__.i(917291)["monoUppercase"],
  "heroMiddle": "LeaderboardHero-module___8BEVG__heroMiddle",
  "heroSection": "LeaderboardHero-module___8BEVG__heroSection",
  "title": "LeaderboardHero-module___8BEVG__title",
  "titleBlock": "LeaderboardHero-module___8BEVG__titleBlock",
});
